/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * ResetPassword Messages
 *
 * This contains all the text for the ResetPassword component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  changePassword: {
    id: 'resetPassword.changePassword',
    defaultMessage: 'Change Password',
  },
  confirmPassword: {
    id: 'resetPassword.confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  missingPassword: {
    id: 'resetPassword.missingPassword',
    defaultMessage: 'Please enter a password in both fields.',
  },
  mixMatch: {
    id: 'resetPassword.mixMatch',
    defaultMessage: 'The password(s) entered do not match.',
  },
  newPassword: {
    id: 'resetPassword.newPassword',
    defaultMessage: 'New Password',
  },
  passwordLength: {
    id: 'resetPassword.passwordLength',
    defaultMessage: 'Must be at least 8 characters in length',
  },
  passwordPolicyText: {
    id: 'resetPassword.passwordPolicyText',
    defaultMessage:
      'Password must have at least 1 alphabetic character, 1 number, and 1 special character (! # $ % - _ = + < > .)',
  },
  passwordUpdateError: {
    id: 'resetPassword.passwordUpdateError',
    defaultMessage: 'Password update failed',
  },
  passwordUpdateSuccess: {
    id: 'resetPassword.passwordUpdateSuccess',
    defaultMessage: 'Password updated successfully!',
  },
  welcome: {
    id: 'resetPassword.welcome',
    defaultMessage: 'Resetting password for',
  },
});
